import { _ as _defineProperty } from '../../unsorted/defineProperty.js';
import { _ as _objectWithoutProperties } from '../../unsorted/objectWithoutProperties.js';
import { CoinbaseSymbol } from './CoinbaseSymbol.js';
import { DocsHorizontalLockup } from './DocsHorizontalLockup.js';
import { DocsHorizontalLockupCompact } from './DocsHorizontalLockupCompact.js';
import { DocsVerticalLockup } from './DocsVerticalLockup.js';
import { GameStopSymbol } from './GameStopSymbol.js';
import { HubHorizontalLockup } from './HubHorizontalLockup.js';
import { HubHorizontalLockupCompact } from './HubHorizontalLockupCompact.js';
import { HubVerticalLockup } from './HubVerticalLockup.js';
import { ImmutableHorizontalLockup } from './ImmutableHorizontalLockup.js';
import { ImmutableSymbol } from './ImmutableSymbol.js';
import { ImmutableVerticalLockup } from './ImmutableVerticalLockup.js';
import { MagicSymbol } from './MagicSymbol.js';
import { MetaMaskSymbol } from './MetaMaskSymbol.js';
import { PassportHorizontalLockup } from './PassportHorizontalLockup.js';
import { PassportHorizontalLockupCompact } from './PassportHorizontalLockupCompact.js';
import { PassportSymbol } from './PassportSymbol.js';
import { PassportSymbolOutlined } from './PassportSymbolOutlined.js';
import { PassportVerticalLockup } from './PassportVerticalLockup.js';
import { RollupX } from './RollupX.js';
import { RollupXFilled } from './RollupXFilled.js';
import { RollupZkevm } from './RollupZkevm.js';
import { RollupZkevmFilled } from './RollupZkevmFilled.js';
import { WalletConnectSymbol } from './WalletConnectSymbol.js';
import { jsx } from '@emotion/react/jsx-runtime';
import '@emotion/react';

function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var lockupLogos = {
  ImmutableHorizontalLockup: ImmutableHorizontalLockup,
  ImmutableVerticalLockup: ImmutableVerticalLockup,
  PassportHorizontalLockup: PassportHorizontalLockup,
  PassportHorizontalLockupCompact: PassportHorizontalLockupCompact,
  PassportVerticalLockup: PassportVerticalLockup,
  HubHorizontalLockup: HubHorizontalLockup,
  HubHorizontalLockupCompact: HubHorizontalLockupCompact,
  HubVerticalLockup: HubVerticalLockup,
  DocsHorizontalLockup: DocsHorizontalLockup,
  DocsHorizontalLockupCompact: DocsHorizontalLockupCompact,
  DocsVerticalLockup: DocsVerticalLockup
};
var immutableSymbolLogos = {
  ImmutableSymbol: ImmutableSymbol,
  PassportSymbol: PassportSymbol,
  PassportSymbolOutlined: PassportSymbolOutlined,
  RollupX: RollupX,
  RollupXFilled: RollupXFilled,
  RollupZkevm: RollupZkevm,
  RollupZkevmFilled: RollupZkevmFilled
};
var otherSymbolLogos = {
  MetaMaskSymbol: MetaMaskSymbol,
  WalletConnectSymbol: WalletConnectSymbol,
  MagicSymbol: MagicSymbol,
  GameStopSymbol: GameStopSymbol,
  CoinbaseSymbol: CoinbaseSymbol
};
var allLogos = _objectSpread$1(_objectSpread$1(_objectSpread$1({}, lockupLogos), immutableSymbolLogos), otherSymbolLogos);

var _excluded = ["logo", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function Logo(_ref) {
  var logo = _ref.logo,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var LogoComponent = allLogos[logo];
  return jsx(LogoComponent, _objectSpread(_objectSpread({}, props), {}, {
    className: "".concat(className, " Logo Logo--").concat(logo)
  }));
}
Logo.displayName = "Logo";

export { Logo as L, allLogos as a, immutableSymbolLogos as i, lockupLogos as l, otherSymbolLogos as o };
//# sourceMappingURL=Logo2.js.map
